export default __webpack_public_path__ + "static/media/coworker_small.40362030.png";